import React from 'react';
import 'antd/dist/antd.css';
import { Layout, Menu, Breadcrumb } from 'antd';
import { Link } from 'gatsby';

const { Footer } = Layout;

export default () => (
    <Footer style={{ textAlign: 'center', backgroundColor: "#dffcff", marginBottom: "0" }}>Wise Code © 2022</Footer>
);